import { ROLES } from "../auth/roles";

import DashboardPrincipalSupervisor from "../layouts/supervisor/DashboardPrincipalSupervisor";
import UserSupervisor from "../layouts/supervisor/UserSupervisor";

import DashboardLockSupervisor from "../layouts/supervisor/DashboardLockSupervisor"
import DashboardLockIdSuper from "../layouts/supervisor/DashboardPadlockIdSuper"
import GrantPadlockPermission from "../layouts/supervisor/GrantPadlockPermission"

export const supervisorRoutes = [
  { path: "/home", element: <DashboardPrincipalSupervisor/>, roles:[ROLES.SUPERVISOR], menu:true },
  { path: "/usuarios", element: <UserSupervisor/>, roles:[ROLES.SUPERVISOR], menu:true },
  { path: "/padlocks", element: <DashboardLockSupervisor/>, roles:[ROLES.SUPERVISOR], menu:true },

  // CANDADOS
  { path: "/padlocks/:serialNumber", element: <DashboardLockIdSuper/>, roles:[ROLES.SUPERVISOR] },

  { path: "/padlocks/:serialNumber/permissions", element: <GrantPadlockPermission/>, roles:[ROLES.SUPERVISOR] },
];
